module.exports = __webpack_public_path__ + "img/mobile_lancamento1.9a54de75.webp";